import { Formik } from "formik";
import { DateTime } from "luxon";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { ErrorText } from "../../../../@ui/ErrorText";
import { StyledModalTitle } from "../../../../@ui/StyledModalTitle";
import { snapshotSchema } from "./snapshotSchema";
import ThemedModal from "../../../../@ui/Modal/ThemedModal";

interface SnapshotModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (windowStartDate: DateTime, windowEndDate: DateTime) => void;
}

interface SnapshotFormData {
  windowStartDate?: string;
  windowEndDate?: string;
}

const SnapshotModal = ({ show, onClose, onSubmit }: SnapshotModalProps) => {
  const submit = (values: SnapshotFormData) => {
    onSubmit(
      DateTime.fromISO(values.windowStartDate!, { zone: "utc" }),
      DateTime.fromISO(values.windowEndDate!, { zone: "utc" })
    );
  };

  const initialValues: SnapshotFormData = {};

  return (
    <ThemedModal centered show={show} onHide={onClose}>
      <Formik
        onSubmit={submit}
        initialValues={initialValues}
        validationSchema={snapshotSchema}
      >
        {({
          values,
          handleSubmit,
          handleChange,
          touched,
          errors,
          handleBlur,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Header className="bg-secondary text-white" closeButton>
              <StyledModalTitle>Create new snapshot</StyledModalTitle>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-3 justify-content-center">
                <Col className="col-md-10">
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="windowStartDate"
                      value={values.windowStartDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                  {errors.windowStartDate && touched.windowStartDate && (
                    <ErrorText className="text-danger">
                      {errors.windowStartDate}
                    </ErrorText>
                  )}
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col className="col-md-10">
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="windowEndDate"
                      value={values.windowEndDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                  {errors.windowEndDate && touched.windowEndDate && (
                    <ErrorText className="text-danger">
                      {errors.windowEndDate}
                    </ErrorText>
                  )}
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" variant="primary">
                Set Snapshot
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </ThemedModal>
  );
};

export default SnapshotModal;
